import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxsModule } from '@ngxs/store';

/* Modules */
import { MaterialModule } from '../../material.module';
import { SharedModule } from '../../shared/shared.module';
import { HierarchyRoutingModule } from './hierarchy-routing.module';
import { BusinessGroupsModule } from '../business-groups/business-groups.module';

/* Services */

/* States */

/* Components */
import { HierarchyPageComponent } from './components/hierarchy-page/hierarchy-page.component';

@NgModule({
  imports: [
    FormsModule,
    HttpClientModule,
    CommonModule,
    NgbModule,
    MaterialModule,
    NgxDatatableModule,
    ReactiveFormsModule,
    HierarchyRoutingModule,
    NgxsModule.forFeature([
    ]),
    BusinessGroupsModule,
    SharedModule
  ],
  declarations: [
    HierarchyPageComponent,
  ],
  providers: [
  ],
  exports: []
})
export class HierarchyModule {
}
